import { childInitials, type VeliChild } from "@/hooks/useVeli";

interface ChildSelectorProps {
  children: VeliChild[];
  activeUserId: string | null;
  onSelect: (userId: string) => void;
}

// Veli panelinde birden fazla çocuk varsa, aktif çocuğu seçmeyi sağlar.
export default function ChildSelector({ children, activeUserId, onSelect }: ChildSelectorProps) {
  if (children.length <= 1) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">
        Öğrenci:
      </span>
      {children.map((c) => {
        const active = c.userId === activeUserId;
        return (
          <button
            key={c.userId}
            type="button"
            onClick={() => onSelect(c.userId)}
            className={`inline-flex items-center gap-2 h-9 pl-2 pr-3 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
              active
                ? "bg-primary-500 text-background-50"
                : "bg-background-50 text-foreground-700 border border-background-200 hover:bg-background-100"
            }`}
          >
            <span
              className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-semibold shrink-0 ${
                active ? "bg-background-50/20 text-background-50" : "bg-background-100 text-foreground-600"
              }`}
            >
              {childInitials(c.fullName)}
            </span>
            {c.fullName}
          </button>
        );
      })}
    </div>
  );
}